import PropTypes from 'prop-types';

export default function TooltipComponent({ content, text, children, position = 'top' }) {
  const displayText = text || content;

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2'
  };

  const arrowClasses = {
    top: 'top-full left-1/2 -translate-x-1/2 -mt-1',
    right: 'right-full top-1/2 -translate-y-1/2 -mr-1',
    bottom: 'bottom-full left-1/2 -translate-x-1/2 -mb-1',
    left: 'left-full top-1/2 -translate-y-1/2 -ml-1'
  };

  return (
    <div className="relative group flex">
      {children}
      <div
        className={`absolute z-50 hidden group-hover:block w-max max-w-[250px] px-3 py-2 rounded-lg bg-gray-900 text-white text-sm font-medium shadow-lg ${positionClasses[position]}`}
      >
        {displayText}
        <div className={`absolute w-2 h-2 bg-gray-900 rotate-45 ${arrowClasses[position]}`} />
      </div>
    </div>
  );
}

TooltipComponent.propTypes = {
  content: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.node.isRequired,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
};

TooltipComponent.defaultProps = {
  content: '',
  text: '',
  position: 'top'
};
